/* lua.js generated code 0.3.0 */

var [Panel, PanelEvent] = unpack(require("clover/panel/MarkPrisePanel"))
var [Button, ButtonEvent] = unpack(require("clover/scene/component/homescene/MarkPriseButton"))
var MarkPriseLogic = xClass("MarkPriseLogic")
var elapseTime = 3600000
var priseButton = null
var buttonDelegateSet = table()
MarkPriseLogic.prototype.ctor = function () {
    var self = this
    self.isBusy = false
}
// pos = {p00, p11}
MarkPriseLogic.prototype.start = function (finishCallback, showPos, hidePos) {
    var self = this
    if (!self.checkMarkPrise()[0]) {
        self.removeMarkPrise()
        if (finishCallback) {
            finishCallback()
        }
        return 
    }
    if (priseButton && priseButton.nodeExist) {
        priseButton.setHided(true)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v && v.nodeExist) {
            v.setHided(true)
        }
    }
    self.finishCallback = finishCallback
    self.showPanel(self.getGoodsInfo(), showPos, hidePos)
}
MarkPriseLogic.prototype.onFinish = function () {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.setHided(false)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v && v.nodeExist) {
            v.setHided(false)
        }
    }
    if (self.finishCallback) {
        self.finishCallback()
    }
}
MarkPriseLogic.prototype.playButtonShakeAnim = function () {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.shakeBox()
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v && v.nodeExist) {
            v.shakeBox()
        }
    }
}
MarkPriseLogic.prototype.showPanel = function (info, showPos, hidePos) {
    var self = this
    function callback(panel) {
        panel.on(PanelEvent.Close, function (evt) {
            if (self.isBusy) {
                return 
            }
            self.isBusy = true
            evt.target.onClose((hidePos || table()).p00, (hidePos || table()).p11, function () {
                self.onFinish()
                self.playButtonShakeAnim()
            })
        })
        panel.on(PanelEvent.Buy, function (evt) {
            if (self.isBusy) {
                return 
            }
            self.isBusy = true
            self.buyGoods(evt.target)
        })
        panel.on(PanelEvent.TimeUp, function (evt) {
            if (self.isBusy) {
                return 
            }
            self.isBusy = true
            if (!self.checkMarkPrise()[0]) {
                self.removeMarkPrise()
                evt.target.onClose(null, null, function () {
                    self.onFinish()
                })
            }
        })
        self.isBusy = true
        panel.popup(true, false, (showPos || table()).p00, (showPos || table()).p11, function () {
            self.isBusy = false
        })
    }
    Panel.asyncCreate(info, callback)
}
MarkPriseLogic.prototype.getGoodsInfo = function () {
    var self = this
    var markRef = MetaManager.getInstance().getMarkConfig()
    var [goodsId, startTime] = self.checkMarkPrise()
    var meta = MetaManager.getInstance().getGoodsMeta(goodsId)
    var index = 5
    for (var i in markRef) {
        var v = markRef[i]
        if (v.goodsId === goodsId) {
            index = i
            break
        }
    }
    return table(
        [1, "dayIdx", index],
        [1, "goodsId", goodsId],
        [1, "priceIcon", GamePropIds.kCash],
        [1, "price", meta.discountQCash],
        [1, "oPrice", meta.qCash],
        [1, "discount", MarketManager.calculateDiscount(meta.discountQCash || 1, meta.qCash || 1)],
        [1, "endTime", startTime + elapseTime],
        [1, "props", clone(meta.items)]
    )
}
MarkPriseLogic.prototype.buyGoods = function (panel) {
    var self = this
    function onSuccess() {
        self.removeMarkPrise()
        panel.playPropAnim(function () {
            panel.onClose(null, null, function () {
                self.onFinish()
            })
        })
    }
    function onFail(evt) {
        function usualProc(evt) {
            if (!self.checkMarkPrise()[0]) {
                self.removeMarkPrise()
                panel.onClose(null, null, function () {
                    self.onFinish()
                })
            } else if (evt) {
                self.isBusy = false
                Toast.make(getText("error.tip." + tostring(evt.data)))
            }
        }
        if (evt.data === ZooErrorCode.CASH_NOT_ENOUGH) {
            // var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
            // var confirm = CashNotEnoughPanel.create(function () {
            //     require("clover/panel/MarketPanel")
            //     MarketPanel.show(MarketPanelTabId.kCashTab, function (market) {
            //         market.setCloseCallback(function () {
            //             self.isBusy = false
            //             market.clearCloseCallback()
            //             usualProc()
            //         })
            //     })
            // }, function () {
            //     self.isBusy = false
            //     usualProc()
            // })
            // confirm.popup(true)
            var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
            CashNotEnoughPanel.show(function (show_panel) {
                show_panel.on(BasePanelEvent.Close, ()=>{
                    self.isBusy = false
                    usualProc()
                })
                // require("clover/panel/MarketPanel")
                // MarketPanel.show(MarketPanelTabId.kCashTab, function (market) {
                //     market.setCloseCallback(function () {
                //         self.isBusy = false
                //         market.clearCloseCallback()
                //         usualProc()
                //     }, function () {
                //         self.isBusy = false
                //     })
                // })
            }, function () {
                self.isBusy = false
                usualProc()
            }, true)
        } else if (evt.data === ZooErrorCode.BUY_LIMIT_GOODS_ERROR_OVER_LIMIT) {
            Toast.make(getText("error.tip." + tostring(evt.data)))
            self.isBusy = false
            self.removeMarkPrise()            
            panel.onClose(null, null, function () {
                self.onFinish()
            })
        } else {
            usualProc(evt)
        }
    }
    function onCancel() {
        if (!self.checkMarkPrise()[0]) {
            self.removeMarkPrise()
            panel.onClose(null, null, function () {
                self.onFinish()
            })
        } else {
            self.isBusy = false
        }
    }
    var [goodsId, startTime] = self.checkMarkPrise()
    if (goodsId) {
        UserDeal.getInstance().buyGoods(goodsId, 1, null, null, null, onSuccess, onFail, onCancel, ModuleName.MARK)
    }
}
MarkPriseLogic.prototype.checkMarkPrise = function () {
    var self = this
    var goodsId = UserLocalSettings.getSetting("MarkPriseGoodsId", 0)
    var startTime = UserLocalSettings.getSetting("MarkPriseStartTime", 0)
    if (Localhost.time() < startTime + elapseTime) {
        return [goodsId, startTime]
    } else {
        self.removeMarkPrise()
        self.removeButton()
    }
    return [null, null]
}
MarkPriseLogic.prototype.addMarkPrise = function (goodsId, time) {
    var self = this
    UserLocalSettings.setSetting("MarkPriseGoodsId", goodsId)
    if (time != null) {
        UserLocalSettings.setSetting("MarkPriseStartTime", tostring(time))
    } else {
        UserLocalSettings.setSetting("MarkPriseStartTime", tostring(Localhost.time()))
    }
    if (priseButton) {
        priseButton.setEndTime((time || Localhost.time()) + elapseTime)
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v.nodeExist) {
            v.setEndTime((time || Localhost.time()) + elapseTime)
        }
    }
    self.createButton()
}
MarkPriseLogic.prototype.removeMarkPrise = function () {
    var self = this
    self.removeButton()
    UserLocalSettings.removeSetting("MarkPriseGoodsId")
    UserLocalSettings.removeSetting("MarkPriseStartTime")
}
MarkPriseLogic.prototype.getMarkPrise = function () {
    var self = this
    // WARN: maybe multi result
    return [UserLocalSettings.getSetting("MarkPriseGoodsId", 0), tonumber(UserLocalSettings.getSetting("MarkPriseStartTime", 0))]
}
MarkPriseLogic.prototype.createButton = function () {
    var self = this
    if(UserManager.getInstance().shouldShowBreakIceIcon()){
        return null
    }
    if (priseButton) {
        var [_, startTime] = self.checkMarkPrise()
        if (startTime) {
            priseButton.setEndTime(startTime + elapseTime)
        }
        return priseButton
    }
    var [_, startTime] = self.checkMarkPrise()
    if (!startTime) {
        return null
    }
    priseButton = Button.create(startTime + elapseTime)
    priseButton.on(ButtonEvent.TimeUp, function () {
        self.checkMarkPrise()
    })
    var HomeScene = require("clover/scene/HomeScene")
    var vSize = cc.Director.getInstance().getVisibleSize()
    // priseButton.setPosition(cc.p(80, 60))
    priseButton.setPosition(cc.p(80, 60 + 140))
    HomeScene.getInstance().addChild(priseButton)
    return priseButton
}
MarkPriseLogic.prototype.delegateButton = function (button) {
    var self = this
    table.insert(buttonDelegateSet, button)
}
MarkPriseLogic.prototype.removeButtonDelegation = function (button) {
    var self = this
    table.removebyvalue(buttonDelegateSet, button)
}
MarkPriseLogic.prototype.removeButton = function () {
    var self = this
    if (priseButton && priseButton.nodeExist) {
        priseButton.removeFromParent(true)
        priseButton = null
    }
    for (var i = 1, v = buttonDelegateSet[1]; v; i++, v = buttonDelegateSet[i]) {
        if (v.nodeExist) {
            v.removeFromParent(true)
        }
    }
    buttonDelegateSet = table()
}
module.exports = MarkPriseLogic
